import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Button, Form } from "react-bootstrap";
import { useFormikContext } from "formik";
import InvoicePaymentRow from "./InvoicePaymentRow";
import { NumericFormat } from "react-number-format";
import { useInvoicePaymentModalFormContext } from "contexts/invoicePage/InvoicePaymentModalFormContext";
import { useInvoiceInitContext } from "contexts/invoicePage/InvoiceInitContext";
import { ModalAllder } from "./ModalAllder";
import InvoicePaymentAdjustOrFee from "./InvoicePaymentAdjustOrFee";
export default function InvoicePaymentModalContent() {
    var values = useFormikContext().values;
    var modalInvoiceModalState = useInvoiceInitContext().modalInvoiceModalState;
    var modalInvPayment = modalInvoiceModalState.modalInvPayment, setModalInvPayment = modalInvoiceModalState.setModalInvPayment;
    var paymentIndex = modalInvPayment.paymentIndex;
    var _useInvoicePaymentModalFormContext = useInvoicePaymentModalFormContext(), form = _useInvoicePaymentModalFormContext.form, setForm = _useInvoicePaymentModalFormContext.setForm, errors = _useInvoicePaymentModalFormContext.errors, parseHeight = _useInvoicePaymentModalFormContext.parseHeight, handleConfirm = _useInvoicePaymentModalFormContext.handleConfirm, onCloseOrCancel = _useInvoicePaymentModalFormContext.onCloseOrCancel, totalToBePaidInModal = _useInvoicePaymentModalFormContext.totalToBePaidInModal, sumPaymentInModal = _useInvoicePaymentModalFormContext.sumPaymentInModal, sumRowsInModal = _useInvoicePaymentModalFormContext.sumRowsInModal, sumAdjustmentsInModal = _useInvoicePaymentModalFormContext.sumAdjustmentsInModal, formHandlerState = _useInvoicePaymentModalFormContext.formHandlerState;
    var setFieldForm = formHandlerState.setFieldForm, addArrayItem = formHandlerState.addArrayItem, removeArrayItem = formHandlerState.removeArrayItem;
    return /*#__PURE__*/ _jsxs(ModalAllder, {
        modal: modalInvPayment,
        setModal: setModalInvPayment,
        htitle: "การรับชำระเงิน",
        hbtn: true,
        onCloseOverride: onCloseOrCancel,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "row overflow-y-auto",
                style: {
                    maxHeight: "calc(".concat(parseHeight(modalInvPayment.height), "px - 18vw)")
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center gap-[30px]",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            "รับชำะเงิน ",
                                            values.doc_number
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "aspect-[228/52] p-[5px] flex justify-center items-center rounded-[8px] w-[228px] fs-18 tc-4 bg-[rgba(45,199,109,0.12)]",
                                        children: [
                                            "รับชำระครั้งที่ ",
                                            paymentIndex + 1
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Group, {
                                className: "mt-[12px]",
                                children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                    dateAdapter: AdapterDayjs,
                                    className: "h-[40px] ",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "grow ",
                                            children: /*#__PURE__*/ _jsx(DatePicker, {
                                                format: "DD/MM/YYYY",
                                                slotProps: {
                                                    textField: {
                                                        InputLabelProps: {
                                                            shrink: true
                                                        },
                                                        error: !!(errors === null || errors === void 0 ? void 0 : errors.pay_date)
                                                    }
                                                },
                                                label: /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        "วันที่รับชำระ ",
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "tc-16",
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                className: "h-[40px] w-full",
                                                sx: {
                                                    ".MuiInputBase-formControl": {
                                                        height: "53px",
                                                        borderRadius: "8px"
                                                    },
                                                    ".MuiFormLabel-root": {
                                                        fontFamily: "Sarabun"
                                                    },
                                                    ".MuiOutlinedInput-notchedOutline": {
                                                        border: "1px solid rgba(76, 78, 100, 0.22)"
                                                    }
                                                },
                                                name: "pay_date",
                                                value: form.pay_date ? dayjs(form.pay_date) : dayjs(),
                                                onChange: function(date) {
                                                    var formattedDate = dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : null;
                                                    setForm(function(prev) {
                                                        return _object_spread_props(_object_spread({}, prev), {
                                                            pay_date: formattedDate
                                                        });
                                                    });
                                                }
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("hr", {
                        className: "my-4",
                        style: {
                            opacity: 0.1
                        }
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "col-12 py-3 d-flex",
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Check, {
                                        type: "switch",
                                        id: "custom-switch-inv-payrow",
                                        label: "",
                                        name: "has_payment_rows",
                                        className: "custom-switch-st-1 mt-1",
                                        onChange: function(e) {
                                            setFieldForm("has_payment_rows", e.target.checked);
                                        },
                                        checked: form.has_payment_rows
                                    }),
                                    /*#__PURE__*/ _jsx("label", {
                                        htmlFor: "custom-switch-inv-payrow",
                                        className: "tc-5 fs-18 fw-bold ",
                                        children: "รายการชำระเงิน"
                                    })
                                ]
                            }),
                            form.has_payment_rows && /*#__PURE__*/ _jsx(InvoicePaymentRow, {
                                paymentIndex: paymentIndex
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("hr", {
                        className: "my-4",
                        style: {
                            opacity: 0.1
                        }
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "col-12 py-3 d-flex",
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Check, {
                                        type: "switch",
                                        id: "custom-switch-inv-adjust-or-fee",
                                        label: "",
                                        name: "has_adjustment_or_fees",
                                        className: "custom-switch-st-1 mt-1",
                                        onChange: function(e) {
                                            setFieldForm("has_adjustment_or_fees", e.target.checked);
                                        },
                                        checked: form.has_adjustment_or_fees
                                    }),
                                    /*#__PURE__*/ _jsx("label", {
                                        htmlFor: "custom-switch-inv-adjust-or-fee",
                                        className: "tc-5 fs-18 fw-bold ",
                                        children: "ค่าธรรมเนียม หรือ รายการปรับปรุง"
                                    })
                                ]
                            }),
                            form.has_adjustment_or_fees && /*#__PURE__*/ _jsx(InvoicePaymentAdjustOrFee, {
                                paymentIndex: paymentIndex
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("hr", {
                        className: "my-4",
                        style: {
                            opacity: 0.1
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "absolute bottom-0 right-0 px-4 py-5",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "h-[74px] flex gap-[64px]",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex flex-col justify-between fs-16",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            "รับชำระด้วยเงินรวม :",
                                            " ",
                                            /*#__PURE__*/ _jsx(NumericFormat, {
                                                displayType: "text",
                                                thousandSeparator: ",",
                                                decimalScale: 2,
                                                fixedDecimalScale: true,
                                                value: sumRowsInModal
                                            }),
                                            " ",
                                            "บาท"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            "ค่าธรรมเนียม หรือ รายการปรับปรุง :",
                                            " ",
                                            /*#__PURE__*/ _jsx(NumericFormat, {
                                                displayType: "text",
                                                thousandSeparator: ",",
                                                decimalScale: 2,
                                                fixedDecimalScale: true,
                                                value: sumAdjustmentsInModal
                                            }),
                                            " ",
                                            "บาท"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            "ถูกหัก ณ ที่จ่าย :",
                                            " ",
                                            /*#__PURE__*/ _jsx(NumericFormat, {
                                                displayType: "text",
                                                thousandSeparator: ",",
                                                decimalScale: 2,
                                                fixedDecimalScale: true,
                                                value: 0
                                            }),
                                            " ",
                                            "บาท"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "bg-[#FF731D] text-white px-[15px] py-[18px] rounded-[8px] flex gap-[10px] items-center",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18",
                                        children: "รับชำระเงินรวมทั้งสิ้น"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "fs-26 font-semibold",
                                        children: [
                                            " ",
                                            /*#__PURE__*/ _jsx(NumericFormat, {
                                                displayType: "text",
                                                thousandSeparator: ",",
                                                decimalScale: 2,
                                                fixedDecimalScale: true,
                                                value: sumPaymentInModal
                                            }),
                                            " ",
                                            "บาท"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "fs-16 flex justify-end mt-[20px] gap-[10px]",
                        children: [
                            "ต้องรับชำระเงินอีก",
                            /*#__PURE__*/ _jsx(NumericFormat, {
                                displayType: "text",
                                thousandSeparator: ",",
                                decimalScale: 2,
                                fixedDecimalScale: true,
                                value: totalToBePaidInModal
                            }),
                            "บาท"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex justify-end gap-[16px] mt-[20px]",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                onClick: function() {
                                    return onCloseOrCancel();
                                },
                                className: "btn-st-6 btn",
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                onClick: function() {
                                    handleConfirm();
                                },
                                className: "btn-st-3 ",
                                children: "ยืนยัน"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
